import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import pure from 'recompose/pure'

import Avatar from '@/ui/Avatar'

const AvatarField = ({
  source,
  record = {},
  localize,
  translate,
  sortable,
  locale,
  fallback,
  resource,
  theme,
  ...props
}) => {
  const image = source ? get(record, source) : false
  if (image) {
    return (
      <Avatar {...props} color={record.color} theme={theme} image={image} cover letter={false} />
    )
  }
  let letters = ''
  if (fallback) {
    letters = get(record, fallback)
    // If there is a space in provided property - asume its "firstname lastname"
    if (letters) {
      if (letters.indexOf(' ') !== -1) {
        letters = letters
          .split(' ')
          .slice(0, 2)
          .map(str => str[0].toUpperCase())
          .join('')
      } else {
        letters = letters.substring(0, 2).toUpperCase()
      }
    }
  }
  if (!image && !letters) return null
  return (
    <Avatar {...props} color={record.color} theme={theme} image={image} cover>
      {letters}
    </Avatar>
  )
}

AvatarField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  fallback: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func,
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
}

const PureAvatarField = pure(AvatarField)

export default PureAvatarField



// WEBPACK FOOTER //
// ./ui/Data/AvatarField.js